export default "__VITE_ASSET__dd8f47de__"